import { notification } from 'antd'
import CommonApi from './Apiservices/CommonAPI'

/*eslint-disable*/
export default create

export async function create(payload) {
  const state = {
    res: false
  }
  await CommonApi.SaveData('/api/v1/admin/payment/method/create', payload)
    .then((response) => {
      notification.success({
        message: response.data.message,
      });
      state.res = true
      return state

    }).catch(error => {
      notification.warning({
        message: error.message,
      });
    })
  return state
}

export function Edit(method, gateway, countries, costflat, costpercentage, id) {
  const state = {
    res: false
  }
  const body =
  {
    method: method,
    gateway: gateway,
    countries: countries,
    cost_flat: costflat,
    cost_percentage: costpercentage,
  }
  CommonApi.SaveData(`/api/v1/admin/payment/method/update/${id}`, body)
    .then((response) => {
      notification.success({
        message: response.data.message,
      });
      state.res = true
      return state

    }).catch(error => {
      notification.warning({
        message: error.message,
      });
    })
  return state

}
